import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includedItems } from '../data/content';
import { carouselTwo } from '../data/carousels';
import { ProjectCarousel } from './ProjectCarousel';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section className="px-6 py-12" style={{
    marginTop: "-50px",
    marginBottom: "-50px"
  }} data-id="element-107" data-mp="pv2iq70gbj83">
      <SectionHeading eyebrow="Everything included" data-id="element-108" data-mp="b6g64d27l5kk">
        What will you <span className="accent-underline" data-id="element-109" data-mp="b5534fgl81ui">find</span> inside?
      </SectionHeading>

      <div className="mt-6 rounded-2xl border border-cream-300 bg-cream-50 px-6 py-5 text-center" data-id="element-110" data-mp="fypqldkk1dfg">
        <p className="font-display text-[22px] font-semibold tracking-[-0.01em] text-gold-500" data-id="element-111" data-mp="27b6t4itp87c">
          +365 projects and activities
        </p>
        <p className="mt-1.5 text-[15px] leading-[1.6] text-ink-500" data-id="element-112" data-mp="3od84hvx6fn6z">
          organized into hands-on projects, experiments, creative builds and printable activities to
          create, learn and play at home.
        </p>
      </div>

      <ul className="mt-8 space-y-6" data-id="element-113" data-mp="3csus4l6r24kz">
        {includedItems.map(item => <li key={item.title} className="flex gap-3.5" data-id="element-114" data-mp="37v32jxtkuujy">
            <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-500/10" aria-hidden="true" data-id="element-115" data-mp="37ul0ulo5bo4n">
              <CheckIcon className="h-3 w-3 text-forest-600" strokeWidth={3} data-id="element-116" data-mp="3hta69eyuvg40" />
            </span>
            <p className="text-[16.5px] leading-[1.65] text-ink-500" data-id="element-117" data-mp="2u3fxp9lkkdpk">
              <span className="font-semibold text-ink-900" data-id="element-118" data-mp="2u1bt0pfujao8">{item.title}</span> {item.detail}
            </p>
          </li>)}
      </ul>

      <div className="-mx-6 mt-10" data-id="element-119" data-mp="32vhu8wsip9uk">
        <ProjectCarousel images={carouselTwo} direction="right" durationSeconds={38} data-id="element-120" data-mp="32wjhs0qpzot6" />
      </div>
    </section>;
}